// src/pages/Industries.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
import CtaBanner from '../components/CtaBanner';

const Industries = () => {
    const { t } = useTranslation();
    const items = t('industries_page.items', { returnObjects: true }) || [];

    return (
        <>
            <PageMeta
                title={t('industries_page.meta_title')}
                description={t('industries_page.meta_description')}
                path="/industries"
            />
            <StructuredData type="page" page={{ name: t('nav.industries'), path: '/industries', description: t('industries_page.meta_description') }} />

            {/* Page header */}
            <div className="bg-slate-900 py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-aos="fade-up">
                    <h1 className="text-4xl font-bold text-white mb-4">{t('industries_page.title')}</h1>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">{t('industries_page.subtitle')}</p>
                </div>
            </div>

            <div className="bg-gray-100 py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-8">
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {Array.isArray(items) && items.map((item, i) => (
                            <div key={i} className="bg-white rounded-lg shadow-xl p-6 border-t-4 border-transparent hover:border-primary transition-all duration-300 hover:shadow-2xl" data-aos="fade-up" data-aos-delay={(i % 3) * 100}>
                                <h2 className="font-bold text-xl text-gray-800 mb-3">{item.title}</h2>
                                <p className="text-gray-600 text-justify">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <CtaBanner
                title={t('industries_page.cta_title')}
                text={t('industries_page.cta_text')}
                buttonLabel={t('common.get_in_touch')}
            />
        </>
    );
};

export default Industries;
